import { configureStore } from "@reduxjs/toolkit";

import { authReducer } from "./auth.slice";
import { usersReducer } from "./user.slice";
import { masterReducer } from "./master.slice";
import { registerReducer } from "./userRegister.slice";
import { validateUserEmailReducer } from "./userEmailExsist.slice";
import { myAccountReducer } from "./myAccount.slice";
import { myContactsReducer } from"./myContacts.slice";
import { findInmatesReducer } from "./findInmates.slice";
import { changePasswordReducer } from "./changePassword.slice";
import { draftMessagesReducer } from "./Draft.slice";
import { writeMessageReducer } from "./writeMessage.slice";
import {purchaseCreditsReducer} from "./purchaseCredits.slice"
import { archivedReducer } from "./archived.slice";
import{sendPhotosReducer} from "./sendPhotos.slice";
import { inboxReducer } from "./inbox.slice";
import { sendEcardsReducer } from "./sendEcards.slice";

export * from "./auth.slice";
export * from "./user.slice";
export * from "./master.slice";
export * from "./myAccount.slice";
export * from "./myContacts.slice";
export * from "./findInmates.slice";
export * from "./changePassword.slice";
export * from "./Draft.slice";
export * from "./writeMessage.slice";
export* from "./sendPhotos.slice";
export * from "./purchaseCredits.slice";
export* from "./inbox.slice";
export *  from "./archived.slice";
export * from "./sendEcards.slice";

export const store = configureStore({
  reducer: {
    users: usersReducer,
    auth: authReducer,
    master: masterReducer,
    validateUserEmail: validateUserEmailReducer,
    register: registerReducer,
    myAccount: myAccountReducer,
    myContacts: myContactsReducer,
    findInmates: findInmatesReducer,
    changePassword: changePasswordReducer,
    draft: draftMessagesReducer,
    WriteMessage: writeMessageReducer,
    sendPhotos: sendPhotosReducer,
    sendEcards: sendEcardsReducer,
    purchaseCredits: purchaseCreditsReducer,
    inbox: inboxReducer,
    archived: archivedReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['auth.connectionData'],
        ignoredActions: ['auth/updateconnectionData'],
      },
    }),

    
  devTools: process.env.REACT_APP_API_ENV !== "production", // Enables DevTools only in development mode
});
